import React from "react";

import { PulseLoader } from "react-spinners";

import { StyledModal } from "../styles";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const SpinnerLoading = () => {
  return (
    <StyledModal data-dismiss="modal">
      <PulseLoader
        color={"#19ade4"}
        loading={true}
        cssOverride={override}
        size={15}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </StyledModal>
  );
};

export default SpinnerLoading;
